import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IAddress, IGeoCodingSuggestion } from '@services/cleanfill-core/address-service/address.model';
import { AddressService } from '@services/cleanfill-core/address-service/address.service';
import { CountryStoreService } from '@services/cleanfill-core/country-service/country-store.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { SnackbarService } from '../snackbar/snackbar.service';

@Component({
  selector: 'widget-geo-code-address-autocomplete',
  templateUrl: './geo-code-address-autocomplete.component.html',
  styleUrls: ['./geo-code-address-autocomplete.component.scss']
})
export class GeoCodeAddressAutocompleteComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  @ViewChild(NgSelectComponent) ngSelect: NgSelectComponent;
  @Output() outputAddressDetailsEvent = new EventEmitter<IAddress>();

  outputAddressDetail: IAddress;
  addressLoading = false;

  @Input() addressSearchFormControl: FormControl;

  @Input() isRequired: boolean;

  addressInput$ = new Subject<string>();

  addressDataSource: IGeoCodingSuggestion[];
  searchValue: string;
  getStreetAddress(address) {
    return address.substring(0, address.indexOf(','));
  }

  private loadAddresses() {
    this.searchValue = '';
    this.subscriptions.add(
      this.addressInput$
        .pipe(
          debounceTime(500),
          distinctUntilChanged(),
          filter(value => value !== '' && value !== null && value !== undefined),
          tap(value => {
            this.addressLoading = true;
            this.searchValue = value;
          }),
          switchMap(() => this.addressService.getGeoCodingAddressSuggestions(this.searchValue))
        )
        .subscribe(response => {
          this.addressLoading = false;
          this.addressDataSource = response.suggestions;
        })
    );
  }

  onCustomerAddressChange(addressSuggestion: IGeoCodingSuggestion) {
    if (addressSuggestion != null) {
      this.addressSearchFormControl.patchValue(this.getStreetAddress(this.addressSearchFormControl.value.text));
      this.addressLoading = true;
      this.subscriptions.add(
        this.addressService.getAddressDetails(addressSuggestion.magicKey).subscribe(addressDetailsResponse => {
          this.addressLoading = false;
          if (!addressDetailsResponse.error) {
            // const countryId = addressDetailsResponse.candidates[0].attributes.Country === 'CAN' ? 1 : 2;
            // const constSelectedCountry = this.countryStoreService.countries.find(m => +m.id === countryId);
            const constSelectedProvince = this.countryStoreService.provinces.find(
              m => m.name.toLowerCase() === addressDetailsResponse.candidates[0].attributes.Region.toLowerCase()
            );

            this.outputAddressDetail = {
              line1: addressDetailsResponse.candidates[0].attributes.StAddr,
              line2: addressDetailsResponse.candidates[0].attributes.SubAddr,
              city: addressDetailsResponse.candidates[0].attributes.City,
              countryId: addressDetailsResponse.candidates[0].attributes.Country,
              provinceId: constSelectedProvince.uniqueId,
              latitude: addressDetailsResponse.candidates[0].location.y,
              longitide: addressDetailsResponse.candidates[0].location.x,
              postalCode: addressDetailsResponse.candidates[0].attributes.Postal + addressDetailsResponse.candidates[0].attributes.PostalExt
            };
            this.outputAddressDetailsEvent.emit(this.outputAddressDetail);
          } else {
            this.snackBarService.error('Token expired!');
          }
        })
      );
    }
  }

  constructor(
    private addressService: AddressService,
    private countryStoreService: CountryStoreService,
    private snackBarService: SnackbarService
  ) {}

  ngOnInit() {
    this.loadAddresses();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  selectUndefinedAddress() {
    this.addressSearchFormControl.patchValue(this.searchValue);
    this.outputAddressDetail = {
      line1: this.searchValue,
      line2: '',
      city: '',
      countryId: undefined,
      provinceId: undefined,
      latitude: undefined,
      longitide: undefined,
      postalCode: ''
    };
    this.outputAddressDetailsEvent.emit(this.outputAddressDetail);
    this.ngSelect.toggle();
  }
}
